import { DateRangePicker as MuiDateRangePicker } from "@mui/x-date-pickers-pro";
import React from "react";
import { dateInput } from "../../utils/formatter";
import dayjs from "dayjs";
import { parseDateTime } from "shared/src/date.mjs";

function rangeToInternal(value) {
  if (value?.[1]?.length > 0) {
    const to = parseDateTime(value[1]);
    to.setDate(to.getDate() - 1);

    return [value[0], dateInput(to)];
  }

  return value;
}

function rangeToExternal(value) {
  if (value?.[1]?.length > 0) {
    const to = parseDateTime(value[1]);
    to.setDate(to.getDate() + 1);

    return [value[0], dateInput(to)];
  }

  return value;
}

/**
 * This component hides using dayjs lib.
 *
 * + simlifies specifying ranges by adding +1 day to the "to" date, thus making [lower, upper) range.
 */

export default function DateRangePicker(props) {
  const [internalValue, setInternalValue] = React.useState(
    rangeToInternal(props.value ?? props.defaultValue ?? ["", ""]),
  );
  const externalValue = rangeToExternal(internalValue);

  const overrides = { ...props };

  overrides.onChange = function (value, context) {
    const internalValue = value.map((value) => dateInput(value?.$d) ?? "");
    setInternalValue(internalValue);
    props?.onChange?.(rangeToExternal(internalValue), context);
  };

  if (props.defaultValue != null) {
    overrides.defaultValue = rangeToInternal(props.defaultValue).map((v) =>
      dayjs(v),
    );
  }

  delete overrides.name;

  return (
    <>
      <MuiDateRangePicker {...overrides} />
      <input type="hidden" name={props.nameFrom} value={externalValue[0]} />
      <input type="hidden" name={props.nameTo} value={externalValue[1]} />
    </>
  );
}
